import Alert from 'bee-alert'

export default Alert
